module.exports = {"id":"224655","name":"Rafael Defendi","rating":"71","photo":"./data/images/photos/0/224655.png","club":{"name":"Paços Ferreira","logo":"./data/images/clubs/PacosFerreira.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RafaelDefendi0.json
// module id = 3507
// module chunks = 0